
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UsageInfo',
  props: {
    completion: {
      type: Number,
      required: true
    }
  }
})
